import CityPageTemplate from "../city-template/CityPageTemplate";
import { radcliffConfig } from "./data";

export default function RadcliffPage() {
  return <CityPageTemplate config={radcliffConfig} />;
}